const constants = {
  FONT_SIZE: 12,
  FONT_SIZE_AXIS: 11,
  MIN_GRID_VALUE: 20,
  MARGIN_CHART_CONTAINER: {
    paddingTop: -35,
    paddingBottom: 0,
    paddingLeft: 5,
    paddingRight: -15,
  },
  DATA_COLLECTION_TIME: [
    {
      date: "1 am",
    },
    {
      date: "2 am",
    },
    {
      date: "3 am",
    },
    {
      date: "4 am",
    },
    {
      date: "5 am",
    },
    {
      date: "6 am",
    },
    {
      date: "7 am",
    },
    {
      date: "8 am",
    },
    {
      date: "9 am",
    },
    {
      date: "10 am",
    },
    {
      date: "11 am",
    },
    {
      date: "12 pm",
    },
    {
      date: "1 pm",
    },
    {
      date: "2 pm",
    },
    {
      date: "3 pm",
    },
    {
      date: "4 pm",
    },
    {
      date: "5 pm",
    },
    {
      date: "6 pm",
    },
    {
      date: "7 pm",
    },
    {
      date: "8 pm",
    },
    {
      date: "9 pm",
    },
    {
      date: "10 pm",
    },
    {
      date: "11 pm",
    },
    {
      date: "12 am",
    },
  ],
  PRIMARY_COLOR: "#2B5784",
};

export default constants;
